import React from 'react';

import BankIconBackground from './BankIconBackground';

import { IconProps } from '.';

const OtherBank: React.FC<React.PropsWithChildren<IconProps>> = ({ size = 36 }) => (
  <svg width={size} height={size} viewBox="0 0 36 36" fill="none" xmlns="http://www.w3.org/2000/svg">
    <BankIconBackground size={size} />
    <svg x="6" y="6" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M17.3944 8L12 4.4037L6.60555 8H17.3944ZM3 8L12 2L21 8V10H3V8Z"
        fill="#1C1E21"
      />
      <path fillRule="evenodd" clipRule="evenodd" d="M21 21L3 21L3 19L21 19V21Z" fill="#1C1E21" />
      <path fillRule="evenodd" clipRule="evenodd" d="M13 17V12H15V17H13Z" fill="#1C1E21" />
      <path fillRule="evenodd" clipRule="evenodd" d="M17 17V12H19V17H17Z" fill="#1C1E21" />
      <path fillRule="evenodd" clipRule="evenodd" d="M9 17V12H11V17H9Z" fill="#1C1E21" />
      <path fillRule="evenodd" clipRule="evenodd" d="M5 17V12H7V17H5Z" fill="#1C1E21" />
    </svg>
  </svg>
);

export default OtherBank;
